import adminModuleGetters from "./adminModule/getters";
import subscription from "./subscription/getters";

export default {
  ...adminModuleGetters,
  ...subscription,
};
